@let title = isEdit ? 'Edit Service Account' : 'Create Service Account';
@let saveBtnText = isEdit ? 'Save' : 'Add Service Account';

<div class="modal-full-page-body">
  <h1 class="title">{{ title }}</h1>

  <div class="form" [class.form-with-error]="formSubmitError">
    <form [formGroup]="createServiceAccountForm">
      <rkt-form [form]="createServiceAccountForm" [fields]="createServiceAccountFields" [model]="formModel"></rkt-form>
    </form>
  </div>

  @if (formSubmitError) {
    <div class="error-container">
      <div class="separator"></div>
      <div class="details-page-edit-form-error">{{ formSubmitError }}</div>
    </div>
  }

  <div class="footer">
    <div class="separator"></div>
    <div class="buttons">
      <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>

      <button rktButton type="submit" (click)="onSubmit()" [title]="saveBtnText" [disabled]="createServiceAccountForm.invalid || isLoading">
        {{ saveBtnText }}
      </button>
    </div>
  </div>
</div>
